import FieldEditor from "editor/FieldEditor";
import FieldEditorText from "./FieldEditorText";
import Flatpickr from "flatpickr";


class FieldEditorDate extends FieldEditorText {

    create() {
        super.create();

        this.picker = new Flatpickr(this.$input[0], {
            static: true,
            altInput: false,
            dateFormat: 'Y-m-d',
            animate: false
        });

        this.$input.addClass("admin-editor--date");

        if (this.value) {
            this.setValue(this.value);
        }
    }

    setValue(value) {
        if (!this.picker) {
            this.value = value;
            return;
        }
        if ('object' === typeof value) {
            this.picker.setDate(new Date(value.timestamp * 1000));
        } else {
            this.picker.setDate(value);
        }
    }

    destroy() {
        this.picker.destroy();

        super.destroy();
    }

}

FieldEditor.register_editor("date", FieldEditorDate);

export default FieldEditorDate;
